import React, { useState, useEffect } from "react";

import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { getModuleState } from "./../../redux/reducers/ModuleStateReducer";

import OverviewStatus, { EOverviewModuleStatus } from "./OverviewStatus";

import { Module } from "../../Model/Module";
import { EModuleType } from "../../Model/EModuleType";
import { ELoadPortScannedStatus } from "../../Model/ModuleState";

type LoadportStatusProps = {
  module: Module;
};

export default function LoadportStatus(props: LoadportStatusProps) {
  const { module } = props;
  const moduleState = useTypedSelector((state) =>
    getModuleState(state, module.identifier)
  );
  const loadportState = moduleState.loadPort;

  const remainingCapacity = loadportState ? loadportState.remainingCapacity : 0;
  const fullCapacity = loadportState ? loadportState.fullCapacity : 0;

  const availableStorageText = `${remainingCapacity} of ${fullCapacity}`;
  const [loadPortText, setloadPortText] = useState(
    ELoadPortScannedStatus.Unknown.toString()
  );

  useEffect(() => {
    setloadPortText(
      loadportState?.loadPortScannedStatus != null
        ? ELoadPortScannedStatus[loadportState.loadPortScannedStatus].toString()
        : ELoadPortScannedStatus[ELoadPortScannedStatus.Unknown].toString()
    );
  }, [loadportState]);

  const statusses = {
    ["Available Storage"]: availableStorageText,
    Loadport: loadPortText,
    ...(loadportState?.isLoadPortDoorOpen
      ? { Door: loadportState?.isLoadPortDoorOpen ? "Open" : "Secured" }
      : {}),
  };

  return (
    <OverviewStatus
      moduleType={EModuleType.LOADPORT}
      name={module.name}
      statusses={statusses}
      moduleStatus={EOverviewModuleStatus.Idle}
    />
  );
}
